import { BaseWebComponentController } from '../../framework/BaseWebComponentController';
import { NetworkV2AppWebComponent } from '../component/NetworkV2AppWebComponent';
import { NetworkV2AppRepository } from '../repository/NetworkV2AppRepository';
import { NetworkV2AppView } from '../view/NetworkV2AppView';
import { templateNetworkV2App } from '../view/template';
import { NetworkDrillDownData } from '../../networkV2/networkAppContainer/helpers/types';

export class NetworkV2AppController extends BaseWebComponentController {
  public component: NetworkV2AppWebComponent;
  public dataRepository: NetworkV2AppRepository;
  public view: NetworkV2AppView;
  public viewConstructor: typeof NetworkV2AppView;
  public dataRepositoryConstructor: typeof NetworkV2AppRepository;

  constructor(component: NetworkV2AppWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: NetworkV2AppView,
      viewTemplate: templateNetworkV2App,
      dataRepositoryConstructor: NetworkV2AppRepository,
    });
  }

  async getDataForView(): Promise<NetworkDrillDownData> {
    return {
      externalParams: this.component.externalParams,
    };
  }
}
